import { useTranslation } from 'react-i18next'
import ClockIcon from '@mui/icons-material/AccessTimeOutlined'

import { Select } from '../../Form'
import { InputSize } from '../../Form/controls/Input'
import { useSelectedQuote } from '../../../modules/moves'

type TimeControlProps = {
  name: string
  disabled?: boolean
}

const TimeControl: React.FC<TimeControlProps> = ({
  name,
  disabled = false,
}) => {
  const { t } = useTranslation()
  const selectedQuote = useSelectedQuote()

  if (!selectedQuote) {
    return null
  }

  const timeOptions = Object.values(selectedQuote.companyBranch.arrivalWindows ?? {})
    .map(arrivalWindow => ({
      value: arrivalWindow,
      label: t(`arrivalWindows.${String(arrivalWindow)}.title`),
    }))

  return (
    <div className="w-full sm:!w-[350px]">
      <Select
        name={name}
        options={timeOptions}
        startNode={<ClockIcon className="!text-[18px] text-neutral-500" />}
        size={InputSize.Small}
        disabled={disabled}
      />
    </div>
  )
}

export default TimeControl
